import { sendBookingRiderNotificationRequest } from "../../data/bookingRiderNotificationApi";

export async function sendBookingRiderNotificationUseCase(booking) {
  return await sendBookingRiderNotificationRequest({
    vehicleType: 1,
    originLat: Number(booking.origin.lat),
    originLng: Number(booking.origin.lng),
  });
}
